(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["aq-engine"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__aqRevealInit) return;
    window.__aqRevealInit = true;

    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function assignStaggerIndex(root) {
      root.querySelectorAll('[data-aq-stagger-group]').forEach(function (group) {
        group.querySelectorAll('.aq-reveal').forEach(function (el, i) {
          el.style.setProperty('--aq-stagger-index', i);
        });
      });
    }

    function reveal(el) {
      el.classList.add('aq-reveal--visible');
    }

    var observer =
      'IntersectionObserver' in window
        ? new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                  reveal(entry.target);
                  observer.unobserve(entry.target);
                }
              });
            },
            { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
          )
        : null;

    function observeAll() {
      assignStaggerIndex(document);
      document.querySelectorAll('.aq-reveal:not(.aq-reveal--visible)').forEach(function (el) {
        if (prefersReduced || !observer) {
          reveal(el);
        } else {
          observer.observe(el);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeAll);
    } else {
      observeAll();
    }
    document.addEventListener('shopify:section:load', observeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["aq-mercadopago-buy-now"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__aqMpInit) return;
    window.__aqMpInit = true;

    function findForm(root) {
      return root.closest('.shopify-section')
        ? root.closest('.shopify-section').querySelector('form[action*="/cart/add"]')
        : document.querySelector('form[action*="/cart/add"]');
    }

    function nativeAddToCartButton(section) {
      return section ? section.querySelector('[data-add-to-cart-button], button[name="add"]') : null;
    }

    function syncDisabled(root) {
      var section = root.closest('.shopify-section');
      var btn = root.querySelector('[data-aq-mp-button]');
      var nativeBtn = nativeAddToCartButton(section);
      if (!btn) return;
      if (nativeBtn) {
        btn.disabled = nativeBtn.disabled;
      } else {
        btn.disabled = false;
      }
    }

    function init(root) {
      if (root.__aqMpBound) return;
      root.__aqMpBound = true;

      var btn = root.querySelector('[data-aq-mp-button]');
      var label = root.querySelector('[data-aq-mp-label]');
      var errorEl = root.querySelector('[data-aq-mp-error]');
      var defaultLabel = label.innerHTML;
      var busy = false;

      syncDisabled(root);

      var section = root.closest('.shopify-section');
      if (section) {
        section.addEventListener('variant:update', function () {
          syncDisabled(root);
        });
      }

      btn.addEventListener('click', function () {
        if (busy || btn.disabled) return;

        var form = findForm(root);
        if (!form) return;

        var idInput = form.querySelector('[name="id"]');
        var qtyInput = form.querySelector('[name="quantity"]');
        var variantId = idInput ? idInput.value : null;
        var quantity = qtyInput && qtyInput.value ? parseInt(qtyInput.value, 10) : 1;

        if (!variantId) return;

        busy = true;
        errorEl.hidden = true;
        btn.disabled = true;
        label.textContent = 'Procesando…';

        fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
          .then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] }),
            });
          })
          .then(function (response) {
            if (!response.ok) {
              return response.json().then(function (data) {
                throw new Error((data && data.description) || 'cart/add failed');
              });
            }
            return response.json();
          })
          .then(function () {
            window.location.href = '/checkout';
          })
          .catch(function (err) {
            console.error('[aq-mercadopago-buy-now]', err);
            busy = false;
            btn.disabled = false;
            label.innerHTML = defaultLabel;
            errorEl.hidden = false;
          });
      });
    }

    function initAll() {
      document.querySelectorAll('[data-aq-mp]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["aq-notify"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__aqNotifyInit) return;
    window.__aqNotifyInit = true;

    function run(root) {
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-aq-notify-item]'));
      if (!items.length) return;
      var i = 0;

      function hide(el) {
        el.classList.remove('aq-notify__toast--visible');
      }

      function show(el) {
        el.classList.add('aq-notify__toast--visible');
        var seconds = parseInt(el.getAttribute('data-interval'), 10) || 12;
        window.setTimeout(function () {
          hide(el);
          window.setTimeout(next, 600);
        }, Math.max(seconds, 4) * 1000);
      }

      function next() {
        show(items[i % items.length]);
        i++;
      }

      items.forEach(function (el) {
        var closeBtn = el.querySelector('[data-aq-notify-close]');
        if (closeBtn) {
          closeBtn.addEventListener('click', function () {
            hide(el);
          });
        }
      });

      window.setTimeout(next, 2500);
    }

    document.querySelectorAll('[data-aq-notify]').forEach(run);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["aq-price"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__aqPriceInit) return;
    window.__aqPriceInit = true;

    function bind(el) {
      if (el.__aqPriceBound) return;
      el.__aqPriceBound = true;
      var section = el.closest('.shopify-section');
      if (!section) return;

      section.addEventListener('variant:update', function (event) {
        var detail = event.detail;
        if (!detail || !detail.data || !detail.data.html) return;
        var blockId = el.getAttribute('data-block-id');
        var newInner = detail.data.html.querySelector(
          '[data-aq-price][data-block-id="' + blockId + '"] [data-aq-price-inner]'
        );
        var currentInner = el.querySelector('[data-aq-price-inner]');
        if (newInner && currentInner) {
          currentInner.replaceWith(newInner);
        }
      });
    }

    function bindAll() {
      document.querySelectorAll('[data-aq-price]').forEach(bind);
    }

    bindAll();
    document.addEventListener('shopify:section:load', bindAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
